import { render, staticRenderFns } from "./UrlField.vue?vue&type=template&id=9ad6ed08&"
import script from "./UrlField.vue?vue&type=script&lang=js&"
export * from "./UrlField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ad6ed08')) {
      api.createRecord('9ad6ed08', component.options)
    } else {
      api.reload('9ad6ed08', component.options)
    }
    module.hot.accept("./UrlField.vue?vue&type=template&id=9ad6ed08&", function () {
      api.rerender('9ad6ed08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/UrlField.vue"
export default component.exports